import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ModalService } from '@app/shared/modal.service';
import { BonusService } from '@app/core/bonus.service';

@Injectable()
export class WithdrawalModalGuard implements CanActivate {
  constructor(
    private modalService: ModalService,
    private bonusService: BonusService // private countryRestrictionService: CountryRegistrationRestrictionService,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const bonuses = await this.bonusService.getBonuses('active');
    if (bonuses.length) {
      this.modalService.openActiveBonuses({ available: 0 });
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/withdraw/withdraw-modal.guard.ts